module.exports = __webpack_public_path__ + "img/14apecge.8be45cd7.png";